var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var __awaiter = exports && exports.__awaiter || function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function (resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.getFormDataContentLength = void 0;
  function getFormDataContentLength(formData) {
    return __awaiter(this, void 0, void 0, function* () {
      return new Promise((resolve, reject) => {
        formData.getLength((err, length) => {
          if (err != null) {
            reject(err);
          } else {
            resolve(length);
          }
        });
      });
    });
  }
  exports.getFormDataContentLength = getFormDataContentLength;
  return exports;
}